export const SERIAL_STATUS = 'SERIAL_STATUS';
